import { useEffect, useRef } from 'react'
import { useRouter } from 'next/router'

import { useShowDataStore } from '#/shared/lib/hooks/use-show-data'

/**
 * Shows a success toast when returning from payment with ?payment=success
 */
export const PaymentSuccessToast = () => {
	const router = useRouter()
	const { showMessage } = useShowDataStore()
	const handledRef = useRef(false)

	useEffect(() => {
		if (!router.isReady || handledRef.current) return
		if (router.query.payment !== 'success') return

		handledRef.current = true
		showMessage('Подписка успешно обновлена', 'success')

		const { payment: _payment, ...restQuery } = router.query
		void router.replace(
			{ pathname: router.pathname, query: restQuery },
			undefined,
			{ shallow: true }
		)
	}, [router.isReady, router.query.payment, router.pathname, router, showMessage])

	return null
}
